
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index2QTX3qQgCYF6m_BfyirXZ7M7qTtEDpfR1CayFNczEeQMeta } from "/builds/monthly-cloud/flat/web/pages/index.vue?macro=true";
import { default as TermsEYHrs_YfNNY8hzDk_IdKCJmPW69TJgN_45ID8CW_1ffvgMeta } from "/builds/monthly-cloud/flat/web/pages/Terms.vue?macro=true";
import { default as SearchBVoE6HE_45JMrbcP7j0Xqqk_E0wVVZPYK8upy_455o9vzXAMeta } from "/builds/monthly-cloud/flat/web/pages/Search.vue?macro=true";
import { default as BookingSz_ZQBpfAYvIo8BQgyfiArrje3Vu_8LEY11gydOgpiUMeta } from "/builds/monthly-cloud/flat/web/pages/Booking.vue?macro=true";
import { default as ContactsY8JK0zsGKTgk_45et1blgdvV23rNJZu6qYLEog0nbDvEMeta } from "/builds/monthly-cloud/flat/web/pages/Contact.vue?macro=true";
import { default as profile0oSh9w2eRSEXL4MrsQRurjXfE69oY5E_xlXG5VTrvpQMeta } from "/builds/monthly-cloud/flat/web/pages/profile.vue?macro=true";
import { default as Buildingxe_45Qsqu0fZjBVdRJDmFk8Yej798w1ci8IdjwWMQUl_45gMeta } from "/builds/monthly-cloud/flat/web/pages/Building.vue?macro=true";
import { default as PropertymmH6ydL4lC_WrX9IKmoixagE2pIMbp1A2uUPpgdnxCwMeta } from "/builds/monthly-cloud/flat/web/pages/Property.vue?macro=true";
import { default as bookmarkseEhuvl7SGM2nJAmKjTm6v_TS4NRL36mOJ6gEjYYLl0AMeta } from "/builds/monthly-cloud/flat/web/pages/bookmarks.vue?macro=true";
import { default as buildingsDBDNKwRNbcyCfy7CCxcTJsr4T_45qiGeCgizpKLb9NAvAMeta } from "/builds/monthly-cloud/flat/web/pages/buildings.vue?macro=true";
import { default as _91_slug_93lH_VCnbUsH8XkMxXJhCO8B8Mk8hvhzeI8p7nB8kLKd4Meta } from "/builds/monthly-cloud/flat/web/pages/s/[_slug].vue?macro=true";
import { default as indexsqQPgTROBI4mk1efoNhRiNA8wgHzV3eDK48Ln2my1CsMeta } from "/builds/monthly-cloud/flat/web/pages/[city]/index.vue?macro=true";
import { default as virtual_45tourSF8xtNdn91_h1pvv_45b5_ED0R9vZPeWK0gOPyDuZtiBEMeta } from "/builds/monthly-cloud/flat/web/pages/virtual-tour.vue?macro=true";
import { default as BookingRequest_45LO4StQjJtlvbn765Q4i5Mm1aKc3m1DCSC6KJRLIAxQMeta } from "/builds/monthly-cloud/flat/web/pages/BookingRequest.vue?macro=true";
import { default as RegisterStepOneMOixcKqA87p5UmWl91PZIac9pnYQw19lxWOxxcrXrC8Meta } from "/builds/monthly-cloud/flat/web/pages/RegisterStepOne.vue?macro=true";
import { default as RegisterStepTwozMTzV2nzFnNxBjqOtxg0MnS83fHHQUlX8VqM2OhpxSUMeta } from "/builds/monthly-cloud/flat/web/pages/RegisterStepTwo.vue?macro=true";
import { default as RegistrationOne_45sLv8v9eMYOJdwMwRdrBDtgWUjwF7liLYcrT8rjeNewMeta } from "/builds/monthly-cloud/flat/web/pages/RegistrationOne.vue?macro=true";
import { default as RegistrationTwos3EdkZ67C7xighRIgGfF51D_45FGFTm7MCXBsbkH_279AMeta } from "/builds/monthly-cloud/flat/web/pages/RegistrationTwo.vue?macro=true";
import { default as StepOnePE4OVLBY1D_DyFvC2ycvgbpnsvUzFiYWAXhlPveBN_8Meta } from "/builds/monthly-cloud/flat/web/pages/join-flat/StepOne.vue?macro=true";
import { default as RegisterStepThreezNpZKg_r_45AUvt_45ky6e5uGE4n5btf_45lrMqvvk2z4PQQYMeta } from "/builds/monthly-cloud/flat/web/pages/RegisterStepThree.vue?macro=true";
import { default as RegistrationThreetmX9sgd6WfDcSWZWcSp2rEiudNpCUhDyqmhau9fRVAMMeta } from "/builds/monthly-cloud/flat/web/pages/RegistrationThree.vue?macro=true";
import { default as AddPropertyStepOneztA_453uxHOswS4b20_ssmLyYWunokvxNjQLOT90uRUXwMeta } from "/builds/monthly-cloud/flat/web/pages/AddPropertyStepOne.vue?macro=true";
import { default as AddPropertyStepTwoSVP9bei9cXeFVnuvG_45Fv0wTZLmamh5R0AK2_45RzVGWtsMeta } from "/builds/monthly-cloud/flat/web/pages/AddPropertyStepTwo.vue?macro=true";
import { default as availability1KoDwesCNGf8n3xIqykVnj8HU_mwhFZ_45nmKCxYBPb5oMeta } from "/builds/monthly-cloud/flat/web/pages/embed/availability.vue?macro=true";
import { default as AddPropertyStepFourPEAbteCwuzsoxepy70Z8XU5RduqK8JMDPgZCHbFDfvQMeta } from "/builds/monthly-cloud/flat/web/pages/AddPropertyStepFour.vue?macro=true";
import { default as DoneniqAOsn8ixx4YBXpEqfrUsSsQ3HZb8ohyi2QU3SFpc8Meta } from "/builds/monthly-cloud/flat/web/pages/find-me-a-flat/Done.vue?macro=true";
import { default as indexwXf6IlaW9bql8KFF_45zWDVSsFghI3rYbaI1sN1g_lG0MMeta } from "/builds/monthly-cloud/flat/web/pages/[city]/[slug1]/index.vue?macro=true";
import { default as AddPropertyStepThreeNaA4d_rRxlur0u_4573MzHspf_ntYICddf6FPDDB5LZBEMeta } from "/builds/monthly-cloud/flat/web/pages/AddPropertyStepThree.vue?macro=true";
import { default as StepOneUnvtyGDPdRtnUA9ISOKevBrPGbJrT9ofHBkUPNPdbYEMeta } from "/builds/monthly-cloud/flat/web/pages/find-me-a-flat/StepOne.vue?macro=true";
import { default as indexlVJUlpNq6O08YUuCeWCNFx9bKqVZms9f9YvP43bMTLAMeta } from "/builds/monthly-cloud/flat/web/pages/[city]/[slug1]/[slug2]/index.vue?macro=true";
import { default as StepOnefkXv_454jZvYrC1lJxMvT5MZWdDzMKhgkl4Mm_80bS8bsMeta } from "/builds/monthly-cloud/flat/web/pages/open-investor-account/StepOne.vue?macro=true";
import { default as StepOneqYkb4iu8tLT5JqENcdix9Tpy2QyaPzaXLyCLhk0KwiAMeta } from "~/pages/join-flat/StepOne.vue?macro=true";
import { default as StepOnee8AgvGeZPRf_ubnOiyJlc3zbi_45Op4UNYV02bNqQHMEQMeta } from "~/pages/open-investor-account/StepOne.vue?macro=true";
import { default as StepOneF2FJ_45SbdL_ogOkKYHkjuK0ECAgWTXDA7l_45Lzl6w5Zq0Meta } from "~/pages/find-me-a-flat/StepOne.vue?macro=true";
import { default as DoneQz7IPR1EzhVI2Xe2uhhiuw2lI7gJ447Ty3euy9Kfrd8Meta } from "~/pages/find-me-a-flat/Done.vue?macro=true";
import { default as _91_slug_93U3PJCAsh98_ppBS5SwSTuzvkZLxlj9mfQj1EK7KgibcMeta } from "~/pages/s/[_slug].vue?macro=true";
import { default as buildings2ZMO2i8lITaJkjsSoolRxji2X_45zc4jQbgHOUg8KKaxAMeta } from "~/pages/buildings.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/monthly-cloud/flat/web/pages/index.vue")
  },
  {
    name: "Terms",
    path: "/Terms",
    component: () => import("/builds/monthly-cloud/flat/web/pages/Terms.vue")
  },
  {
    name: "Search",
    path: "/Search",
    component: () => import("/builds/monthly-cloud/flat/web/pages/Search.vue")
  },
  {
    name: "Booking",
    path: "/Booking",
    component: () => import("/builds/monthly-cloud/flat/web/pages/Booking.vue")
  },
  {
    name: "Contact",
    path: "/Contact",
    component: () => import("/builds/monthly-cloud/flat/web/pages/Contact.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/builds/monthly-cloud/flat/web/pages/profile.vue")
  },
  {
    name: "Building",
    path: "/Building",
    component: () => import("/builds/monthly-cloud/flat/web/pages/Building.vue")
  },
  {
    name: "Property",
    path: "/Property",
    component: () => import("/builds/monthly-cloud/flat/web/pages/Property.vue")
  },
  {
    name: "bookmarks",
    path: "/bookmarks",
    component: () => import("/builds/monthly-cloud/flat/web/pages/bookmarks.vue")
  },
  {
    name: "buildings",
    path: "/buildings",
    component: () => import("/builds/monthly-cloud/flat/web/pages/buildings.vue")
  },
  {
    name: "s-_slug",
    path: "/s/:_slug()",
    component: () => import("/builds/monthly-cloud/flat/web/pages/s/[_slug].vue")
  },
  {
    name: "city",
    path: "/:city()",
    component: () => import("/builds/monthly-cloud/flat/web/pages/[city]/index.vue")
  },
  {
    name: "virtual-tour",
    path: "/virtual-tour",
    component: () => import("/builds/monthly-cloud/flat/web/pages/virtual-tour.vue")
  },
  {
    name: "BookingRequest",
    path: "/BookingRequest",
    component: () => import("/builds/monthly-cloud/flat/web/pages/BookingRequest.vue")
  },
  {
    name: "RegisterStepOne",
    path: "/RegisterStepOne",
    component: () => import("/builds/monthly-cloud/flat/web/pages/RegisterStepOne.vue")
  },
  {
    name: "RegisterStepTwo",
    path: "/RegisterStepTwo",
    component: () => import("/builds/monthly-cloud/flat/web/pages/RegisterStepTwo.vue")
  },
  {
    name: "RegistrationOne",
    path: "/RegistrationOne",
    component: () => import("/builds/monthly-cloud/flat/web/pages/RegistrationOne.vue")
  },
  {
    name: "RegistrationTwo",
    path: "/RegistrationTwo",
    component: () => import("/builds/monthly-cloud/flat/web/pages/RegistrationTwo.vue")
  },
  {
    name: "join-flat-StepOne",
    path: "/join-flat/StepOne",
    component: () => import("/builds/monthly-cloud/flat/web/pages/join-flat/StepOne.vue")
  },
  {
    name: "RegisterStepThree",
    path: "/RegisterStepThree",
    component: () => import("/builds/monthly-cloud/flat/web/pages/RegisterStepThree.vue")
  },
  {
    name: "RegistrationThree",
    path: "/RegistrationThree",
    component: () => import("/builds/monthly-cloud/flat/web/pages/RegistrationThree.vue")
  },
  {
    name: "AddPropertyStepOne",
    path: "/AddPropertyStepOne",
    component: () => import("/builds/monthly-cloud/flat/web/pages/AddPropertyStepOne.vue")
  },
  {
    name: "AddPropertyStepTwo",
    path: "/AddPropertyStepTwo",
    component: () => import("/builds/monthly-cloud/flat/web/pages/AddPropertyStepTwo.vue")
  },
  {
    name: "embed-availability",
    path: "/embed/availability",
    meta: availability1KoDwesCNGf8n3xIqykVnj8HU_mwhFZ_45nmKCxYBPb5oMeta || {},
    component: () => import("/builds/monthly-cloud/flat/web/pages/embed/availability.vue")
  },
  {
    name: "AddPropertyStepFour",
    path: "/AddPropertyStepFour",
    component: () => import("/builds/monthly-cloud/flat/web/pages/AddPropertyStepFour.vue")
  },
  {
    name: "find-me-a-flat-Done",
    path: "/find-me-a-flat/Done",
    component: () => import("/builds/monthly-cloud/flat/web/pages/find-me-a-flat/Done.vue")
  },
  {
    name: "city-slug1",
    path: "/:city()/:slug1()",
    component: () => import("/builds/monthly-cloud/flat/web/pages/[city]/[slug1]/index.vue")
  },
  {
    name: "AddPropertyStepThree",
    path: "/AddPropertyStepThree",
    component: () => import("/builds/monthly-cloud/flat/web/pages/AddPropertyStepThree.vue")
  },
  {
    name: "find-me-a-flat-StepOne",
    path: "/find-me-a-flat/StepOne",
    component: () => import("/builds/monthly-cloud/flat/web/pages/find-me-a-flat/StepOne.vue")
  },
  {
    name: "city-slug1-slug2",
    path: "/:city()/:slug1()/:slug2()",
    component: () => import("/builds/monthly-cloud/flat/web/pages/[city]/[slug1]/[slug2]/index.vue")
  },
  {
    name: "open-investor-account-StepOne",
    path: "/open-investor-account/StepOne",
    component: () => import("/builds/monthly-cloud/flat/web/pages/open-investor-account/StepOne.vue")
  },
  {
    name: "for-hosts",
    path: "/for-hosts",
    component: () => import("~/pages/join-flat/StepOne.vue")
  },
  {
    name: "join-flat-step-one-en",
    path: "/join-flat",
    component: () => import("~/pages/join-flat/StepOne.vue")
  },
  {
    name: "join-flat-step-one-pt",
    path: "/anuncie-seu-flat",
    component: () => import("~/pages/join-flat/StepOne.vue")
  },
  {
    name: "open-investor-account-step-one-en",
    path: "/open-investor-account",
    component: () => import("~/pages/open-investor-account/StepOne.vue")
  },
  {
    name: "open-investor-account-step-one-pt",
    path: "/abrir-conta-de-investidor",
    component: () => import("~/pages/open-investor-account/StepOne.vue")
  },
  {
    name: "register-step-one-pt",
    path: "/encontrar-um-flat",
    component: () => import("~/pages/find-me-a-flat/StepOne.vue")
  },
  {
    name: "register-done-pt",
    path: "/encontrar-um-flat/done",
    component: () => import("~/pages/find-me-a-flat/Done.vue")
  },
  {
    name: "register-step-one-en",
    path: "/find-me-a-flat",
    component: () => import("~/pages/find-me-a-flat/StepOne.vue")
  },
  {
    name: "register-done-en",
    path: "/find-me-a-flat/done",
    component: () => import("~/pages/find-me-a-flat/Done.vue")
  },
  {
    name: "search-retnals-es",
    path: "/en-alquiler/:slug",
    component: () => import("~/pages/s/[_slug].vue")
  },
  {
    name: "search-sales-pt",
    path: "/en-venta/:slug",
    component: () => import("~/pages/s/[_slug].vue")
  },
  {
    name: "search-retnals-pt",
    path: "/para-alugar/:slug",
    component: () => import("~/pages/s/[_slug].vue")
  },
  {
    name: "search-sales-pt",
    path: "/para-venda/:slug",
    component: () => import("~/pages/s/[_slug].vue")
  },
  {
    name: "search-retnals-en",
    path: "/for-rent/:slug",
    component: () => import("~/pages/s/[_slug].vue")
  },
  {
    name: "search-sales-en",
    path: "/for-sale/:slug",
    component: () => import("~/pages/s/[_slug].vue")
  },
  {
    name: "buildings-pt",
    path: "/edificios",
    component: () => import("~/pages/buildings.vue")
  }
]